import { v4 as uuid } from "uuid"

import getUpdatedMatrix from "reducers/lockingSystemReducer/utils/getUpdatedMatrix"
import getLockingSystemPricePortions, {
	getLockingSystemMsrpPricePortions,
} from "reducers/lockingSystemReducer/utils/getLockingSystemPricePortions"
import getNameOfDuplicatedComponent from "reducers/lockingSystemReducer/utils/getNameOfDuplicatedComponent"

import {
	DispatchLockingSystemReducer,
	LockingSystemReducerState,
} from "reducers/lockingSystemReducer"
import { LockingSystemComponent } from "@secureo/common/typings/LockingSystem"

type DuplicateLockingComponentPayload = Pick<
	LockingSystemReducerState,
	| "lockingComponentsUuids"
	| "componentsByUuid"
	| "matrix"
	| "matrixType"

	// Price
	| "singleNetPriceCents"
	| "singleGrossPriceCents"
	| "totalNetPriceCents"
	| "totalGrossPriceCents"

	// Msrp price
	| "singleNetMsrpPriceCents"
	| "singleGrossMsrpPriceCents"
	| "totalNetMsrpPriceCents"
	| "totalGrossMsrpPriceCents"
>

export const duplicateLockingComponent = (
	dispatch: DispatchLockingSystemReducer,
	reducerState: LockingSystemReducerState,
	uuidToDuplicate: string,
) => {
	const { lockingComponentsUuids, keyComponentsUuids, quantity, matrix } = reducerState

	const componentToDuplicate = reducerState.componentsByUuid[uuidToDuplicate]

	const lockingComponent: LockingSystemComponent = {
		...componentToDuplicate,
		name: getNameOfDuplicatedComponent(componentToDuplicate.name),
		uuid: uuid(),
	}

	// Insert component after duplicated component
	const index = reducerState.lockingComponentsUuids.indexOf(uuidToDuplicate)
	lockingComponentsUuids.splice(index + 1, 0, lockingComponent.uuid)

	const lockingComponentMatrixRow = [...matrix[index]]
	matrix.splice(index + 1, 0, lockingComponentMatrixRow)

	const { matrix: updatedMatrix, matrixType } = getUpdatedMatrix(
		lockingComponentsUuids,
		keyComponentsUuids,
		matrix,
	)

	const componentsByUuid = {
		...reducerState.componentsByUuid,
		[lockingComponent.uuid]: lockingComponent,
	}

	const { singleNetPriceCents, singleGrossPriceCents, totalNetPriceCents, totalGrossPriceCents } =
		getLockingSystemPricePortions(componentsByUuid, quantity)

	const {
		singleNetMsrpPriceCents,
		singleGrossMsrpPriceCents,
		totalNetMsrpPriceCents,
		totalGrossMsrpPriceCents,
	} = getLockingSystemMsrpPricePortions(componentsByUuid, quantity)

	const payload: DuplicateLockingComponentPayload = {
		lockingComponentsUuids,
		componentsByUuid,
		matrix: updatedMatrix,
		matrixType,

		// Price
		singleNetPriceCents,
		singleGrossPriceCents,
		totalNetPriceCents,
		totalGrossPriceCents,

		// Msrp price
		singleNetMsrpPriceCents,
		singleGrossMsrpPriceCents,
		totalNetMsrpPriceCents,
		totalGrossMsrpPriceCents,
	}

	dispatch({
		type: "ADD_LOCK_COMPONENT",
		payload,
	})
}
